module.exports = __webpack_public_path__ + "static/img/logo_m_wysd.9f5dbde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/home/imgs/customer-case/logo_m_wysd.jpg
// module id = 7q8L
// module chunks = 0